'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
exports.default = {
  header: '',
  item: '<a class="{{cssClasses.link}}" href="{{url}}">{{name}} <span class="{{cssClasses.count}}">{{#helpers.formatNumber}}{{count}}{{/helpers.formatNumber}}</span></a>',
  footer: ''
};


// WEBPACK FOOTER //
// ./~/instantsearch.js/dist-es5-module/src/widgets/menu/defaultTemplates.js